import React from 'react';
import UIAppList from '../../core/layouts/app_list.js';
import List, {ListItem, ListItemIcon, ListItemText,ListSubheader,} from 'material-ui/List';
import UIIcon from '../../core/ui/icon.js';
import { withStyles } from 'material-ui/styles';

const styles = theme => ({
  root :{
    padding: 5,
  },
});


class AppDrawer extends React.Component {
	render(){
		var key = 0;
		const classes = this.props.classes;
  	return(
  		<UIAppList>
  			<div className={classes.root}>
					<List dense={true}>
						{this.props.options && 
							<div>
			          <ListSubheader>Options</ListSubheader>
								{this.props.options.map(item => 
									<ListItem key={key++}>
										{item}
									</ListItem>
								)}
							</div>
						}
	          <ListSubheader>Menu</ListSubheader>
							<ListItem button disabled={true}>
								<ListItemIcon>
									<UIIcon icon='search'/>
								</ListItemIcon>
								<ListItemText inset primary={'Search'} />
							</ListItem>
							<ListItem button disabled={true}>
								<ListItemIcon>
									<UIIcon icon='history'/>
								</ListItemIcon>
								<ListItemText inset primary={'History'} />
							</ListItem>
							<ListItem button disabled={true}>
								<ListItemIcon>
									<UIIcon icon='settings'/>
								</ListItemIcon>
								<ListItemText inset primary={'Settings'} />
							</ListItem>
					</List>
				</div>
			</UIAppList>
	    );
  	}
}

export default withStyles(styles)(AppDrawer);


// WEBPACK FOOTER //
// ./src/search/ui/app_drawer.js